module.exports = __webpack_public_path__ + "static/6-f3961238c49473056da32a461eb31f05.jpeg";